import { Helmet } from "react-helmet";
import BenefitsOfPvrCabs from "./transportation/transportation-benefits-of-pvr-c-abs";
import TransportationHero from "./transportation/transportation-hero";
import TransportationOneStepSolution from "./transportation/transportation-one-step-solution";
import TransportationWhyChooseUs from "./transportation/transportation-why-choose-us";

export function EmployeeTransportation() {
  return (
    <>
      <Helmet>
        <title>Employee Transportation Services in Hyderabad | PVR CABS</title>
        <meta name="description" content="Reliable IT employee transportation services in Hyderabad by PVR CABS. 24/7 safe and punctual transport for companies and professionals." />
        <link rel="canonical" href="https://pvrcabs.com/employee-transportation" />
      </Helmet>
      <div className="relative w-full h-full mt-2">
        <TransportationHero />
        <TransportationOneStepSolution />
        <TransportationWhyChooseUs />
        <BenefitsOfPvrCabs />
      </div>
    </>
  );
}
